import { render, staticRenderFns } from "./ParcelDetails.vue?vue&type=template&id=1009d051"
import script from "./ParcelDetails.vue?vue&type=script&lang=js"
export * from "./ParcelDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports